import { UseGetReportingHomeDataProps } from '@components/containers/ReportsPage/types';
import useReportingHomeData from './reportingHome';

const useOutcomes = ({ dateFilter }: UseGetReportingHomeDataProps) => {
  return useReportingHomeData({ dateFilter, endpoint: 'outcomes' });
}

export default useOutcomes;
